// extracted by mini-css-extract-plugin
module.exports = {"SlideDrawer":"SlideDrawer_SlideDrawer__1nSpR","Open":"SlideDrawer_Open___oJdJ","Close":"SlideDrawer_Close__1K5Dn"};